import { api } from '@/shared/api';
import type { AppDispatch } from '@/app/store';

/**
 * Слияние анонимных корзин с корзинами пользователя. Зовётся после логина:
 * анонимные бэк находит по deviceId из заголовка X-Device-Id.
 */
export async function mergeCarts(dispatch: AppDispatch): Promise<void> {
  await dispatch(api.endpoints.mergeCarts.initiate()).unwrap();
}
